import { Modal } from '@leagueplatform/genesis-core';
import { useNavigate } from 'react-router-dom';
import { useProviderRedirect } from 'hooks/use-pcp-provider-redirect.hook';
import { InpatientCareGateModal } from 'components/modals/inpatient-care-gate-modal.component';

export const ProviderRedirectPage = () => {
  const { constructRedirectUrl, isReady } = useProviderRedirect();
  const navigate = useNavigate();

  const handleProceed = () => {
    window.location.href = constructRedirectUrl();
  };

  const handleClose = () => {
    navigate('/get-care');
  };

  return (
    <Modal.Root
      open
      onOpenChange={(open) => {
        if (!open) handleClose();
      }}
    >
      <InpatientCareGateModal
        onProceed={handleProceed}
        onClose={handleClose}
        canProceed={isReady}
      />
    </Modal.Root>
  );
};
